module.exports = __webpack_public_path__ + "assets/img/subscription.379029ed.svg";